export default __webpack_public_path__ + "static/inUW-b9103f627a62f8607562d9fbc85ea0a0.png";